// extracted by mini-css-extract-plugin
module.exports = {"actionsMenu":"actionsMenu--3g95J","actions-transition":"actions-transition--1qHHQ","title":"title--1lD8K","option":"option--3UouW"};